<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Sujata Krishnan hails from India and was raised in Kuwait. After working for about 12 years and then becoming a full-time mother, she has decided to concentrate her skills on writing. Now settled in Dubai, Sujata has written her first book, <em>The Dynamic Doorway</em>, which started as a night-time story for her son.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?70a6217a